/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Root
 */
export interface Root {
  /**
   *
   * @type {string}
   * @memberof Root
   */
  status: string;
  /**
   *
   * @type {string}
   * @memberof Root
   */
  sendLoginLink: string;
  /**
   *
   * @type {string}
   * @memberof Root
   */
  projects: string;
  /**
   *
   * @type {string}
   * @memberof Root
   */
  users: string;
  /**
   *
   * @type {string}
   * @memberof Root
   */
  openapiSchema: string;
  /**
   *
   * @type {string}
   * @memberof Root
   */
  swaggerUi: string;
}

/**
 * Check if a given object implements the Root interface.
 */
export function instanceOfRoot(value: object): value is Root {
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("sendLoginLink" in value) || value["sendLoginLink"] === undefined) return false;
  if (!("projects" in value) || value["projects"] === undefined) return false;
  if (!("users" in value) || value["users"] === undefined) return false;
  if (!("openapiSchema" in value) || value["openapiSchema"] === undefined) return false;
  if (!("swaggerUi" in value) || value["swaggerUi"] === undefined) return false;
  return true;
}

export function RootFromJSON(json: any): Root {
  return RootFromJSONTyped(json, false);
}

export function RootFromJSONTyped(json: any, ignoreDiscriminator: boolean): Root {
  if (json == null) {
    return json;
  }
  return {
    status: json["status"],
    sendLoginLink: json["send_login_link"],
    projects: json["projects"],
    users: json["users"],
    openapiSchema: json["openapi_schema"],
    swaggerUi: json["swagger_ui"],
  };
}

export function RootToJSON(json: any): Root {
  return RootToJSONTyped(json, false);
}

export function RootToJSONTyped(value?: Root | null, ignoreDiscriminator: boolean = false): any {
  if (value == null) {
    return value;
  }

  return {
    status: value["status"],
    send_login_link: value["sendLoginLink"],
    projects: value["projects"],
    users: value["users"],
    openapi_schema: value["openapiSchema"],
    swagger_ui: value["swaggerUi"],
  };
}
